import { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { ProtectedPaths } from "routes";
import React from "react";
import {
  createProductionForecasts,
  exportProductionForecastGroup,
} from "api/resources/productionForecasts";
import Typography from "@mui/material/Typography";
import { downloadXLSX } from "../../../../helpers/excelExport";

export default function ProductionForecastGroupsTable({
  forecastGroups,
  date,
  dispatch,
  setSnackbar,
}: any) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(null);

  const handleCreateNewForecasts = () => {
    setLoading(true);

    createProductionForecasts(dayjs(date).format("YYYY-MM-DD"))
      .then(() => {
        setLoading(false);
        dispatch();
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const handleExportForecastGroup = (groupId: number) => {
    setExporting(groupId);

    exportProductionForecastGroup(groupId, {})
      .then((result) => {
        downloadXLSX(
          result,
          `Forecast_group-${dayjs(date).format("YYYY-MM-DD")}.xlsx`,
        );
        setSnackbar({
          type: "success",
          message: "Production forecast group exported",
        });
        setExporting(null);
      })
      .catch((error) => {
        console.error(error);
        setSnackbar({
          type: "error",
          message: error.message,
        });
        setExporting(null);
      });
  };

  const canCreateForecasts = !dayjs(date).isBefore(dayjs().subtract(1, "day"));

  return (
    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
      {forecastGroups.length > 0 ? (
        <TableContainer sx={{ maxWidth: 600 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Created by</TableCell>
                <TableCell align="center">Created at</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {forecastGroups.map((forecastGroup: any, index: number) => {
                return (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {forecastGroup.createdBy}
                    </TableCell>
                    <TableCell align="center">
                      {forecastGroup.createdAt
                        ? dayjs(forecastGroup.createdAt).format(
                            "DD.MM.YYYY HH:mm",
                          )
                        : ""}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="text"
                        onClick={() =>
                          navigate(
                            `/${ProtectedPaths.Production}/${forecastGroup.id}`,
                          )
                        }
                      >
                        Open
                      </Button>
                      <LoadingButton
                        size="small"
                        variant="text"
                        loading={exporting === forecastGroup.id}
                        loadingIndicator="Exporting"
                        disabled={exporting === forecastGroup.id}
                        onClick={() =>
                          handleExportForecastGroup(forecastGroup.id)
                        }
                      >
                        Export
                      </LoadingButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography component="p" sx={{ mt: 1.6 }}>
          No forecasts have been generated for this date yet.
        </Typography>
      )}
      {canCreateForecasts && (
        <LoadingButton
          variant="contained"
          size="small"
          sx={{ mt: 1 }}
          onClick={handleCreateNewForecasts}
          loading={loading}
          disabled={loading}
          loadingIndicator="Creating..."
        >
          Create new forecasts
        </LoadingButton>
      )}
    </Box>
  );
}
